import { __extends } from "tslib";
import { DataBuffer } from '../dataBuffer';
/** @hidden */
var WebGLDataBuffer = /** @class */ (function (_super) {
    __extends(WebGLDataBuffer, _super);
    function WebGLDataBuffer(resource) {
        var _this = _super.call(this) || this;
        _this._buffer = resource;
        return _this;
    }
    Object.defineProperty(WebGLDataBuffer.prototype, "underlyingResource", {
        get: function () {
            return this._buffer;
        },
        enumerable: false,
        configurable: true
    });
    return WebGLDataBuffer;
}(DataBuffer));
export { WebGLDataBuffer };
//# sourceMappingURL=webGLDataBuffer.js.map